module.exports = __webpack_public_path__ + "img/demo.c20e6dac.jpg";